import katex from "katex";
import "katex/dist/katex.min.css";
import { EditorClasses } from "../../styles.js";
import { html } from "../../helpers/html-template.js";
import { toVueComponent } from "@scalar-org/vue-render";
import { safeCompute } from "../../helpers/safe-compute.js";
function guideMathHtml(props) {
  const katexContent = safeCompute({
    method: () => katex.renderToString(props.equation || ""),
    fallback: "Invalid Latex provided"
  });
  return html`
    <figure
      class="${EditorClasses.Math}">
      <div
        class="katex-display">${katexContent}</div>
      ${props.caption && html`<figcaption>${props.caption}</figcaption>`}
    </figure>
  `;
}
const ScalarMathVue = toVueComponent(guideMathHtml, {
  equation: String,
  caption: String
});
export {
  ScalarMathVue,
  guideMathHtml
};
//# sourceMappingURL=components.js.map
